import React from 'react'
import cx from 'classnames'

import { Box } from 'components/layout/Box/Box'
import { Dropdown } from 'components/shared/Dropdown/Dropdown'
import { Checkbox } from 'components/shared/FormFields/common/Checkbox/Checkbox'
import styles from './DropdownMenu.module.scss'

type FilterConfigEntry = {
  key: string
  label?: React.ReactNode
  toggleValue?: (current: unknown) => unknown
}

type DropdownMenuProps = {
  onClick?: (filter: Record<string, unknown>) => void
  filter?: Record<string, unknown>
  filtersConfig?: FilterConfigEntry[]
  className?: string
}

export const DropdownMenu = ({
  onClick,
  filter = {},
  filtersConfig = [],
  className,
}: DropdownMenuProps) => {
  const ref = React.useRef<HTMLInputElement>(null)

  const handleToggle = (toggleValue, key) =>
    onClick?.({ ...filter, [key]: toggleValue(filter[key]) })

  return (
    <Dropdown.Menu className={cx(styles.menu, className)}>
      <Box direction="column" className={styles.filters}>
        {filtersConfig.map(({ key, label, toggleValue }) => (
          <div className={styles.container} key={key}>
            <Checkbox
              value={Boolean(filter[key])}
              fieldClassName={styles.checkbox}
              onChange={e => handleToggle(toggleValue, key)}
              ref={ref}
              key={String(label)}
            />
            <div
              className={styles.label}
              onClick={() => handleToggle(toggleValue, key)}
            >
              {label}
            </div>
          </div>
        ))}
      </Box>
    </Dropdown.Menu>
  )
}
